import z from 'zod';

import { CONTROLLING_PARTY_CUSTOM_ROLE_MAX_LENGTH } from '@dealstack/shared/lib/common/business/controllingParty';
import { PersonRelationType } from '@dealstack/shared/lib/generated';
import { RELATED_PEOPLE_FORM_FIELDS } from './types';

export const RelatedPeopleFormShape = z
	.object({
		[RELATED_PEOPLE_FORM_FIELDS.relation_type]: z.nativeEnum(PersonRelationType),
		[RELATED_PEOPLE_FORM_FIELDS.person_ids]: z.array(z.string()),
		[RELATED_PEOPLE_FORM_FIELDS.create_legal_rep]: z.boolean().optional(),
		[RELATED_PEOPLE_FORM_FIELDS.custom_relation_type]: z
			.string()
			.trim()
			.max(CONTROLLING_PARTY_CUSTOM_ROLE_MAX_LENGTH)
			.optional(),
	})
	// The free-text role is mandatory for OTHER — mirrors the API's rule.
	.superRefine((values, ctx) => {
		if (
			values[RELATED_PEOPLE_FORM_FIELDS.relation_type] === PersonRelationType.OTHER &&
			!values[RELATED_PEOPLE_FORM_FIELDS.custom_relation_type]?.trim()
		) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: [RELATED_PEOPLE_FORM_FIELDS.custom_relation_type],
				message: 'Required',
			});
		}
	});
